import { listDrugs } from './index';

import { drugsRouteStore } from '../domain/store';

export default (number) => {
  drugsRouteStore.setValue('currentPage', number);
  return listDrugs();
};
